module.exports = __webpack_public_path__ + "static/fonts/iconfont.4e1cf94.woff2";